import { Header, Menu, Footer } from "./components/index";
import "./App.css";

export const App = () => {
  return (
    <div>
      <Header />
      <Menu />
      <Footer />
    </div>
  );
};

export default App;
